import { Button } from '../buttons/Button'
import { Clipboard } from '../buttons/Clipboard'
import { Heading } from '../Heading'
import { Loader } from '../Loader'
import { Stack } from '../Stack'
import { TinyBox } from '../TinyBox'

type phoneNumber = {
  type: string
  number: string
}

type ReportDamageProps = {
  data?: {
    phoneNumbers: phoneNumber[]
    code: string
    homepage: string
  }
  isLoading?: boolean
  isError?: boolean
  navigateToHome: () => void
}

export function ReportDamage({ data, isLoading, isError, navigateToHome }: ReportDamageProps) {
  if (isLoading) {
    return (
      <div className="ap:w-full ap:min-h-[120px] ap:min-w-[200px] ap:flex ap:items-center ap:justify-center">
        <Loader />
      </div>
    )
  }

  if (isError) {
    return (
      <div className="ap:w-full ap:min-h-[120px] ap:min-w-[200px] ap:flex ap:items-center ap:justify-center">
        <p className="ap:text-content-danger">Noe gikk galt...</p>
      </div>
    )
  }

  const findClaim = data?.phoneNumbers?.find((phone: phoneNumber) => phone.type === 'claim')

  return (
    <Stack spacing="md" className="ap:items-start ap:relative">
      <Stack spacing="flush">
        <p className="ap:text-offGrey">
          Din forsikringspartner som sist var kjent for oss er{' '}
          <span className="ap:font-bold ap:text-primary">{data?.code ? data?.code : 'Ukjent'}</span>.
        </p>
        {data?.homepage && (
          <p>
            Gå til
            <a className="ap:text-primary ap:font-semibold ap:hover:underline ap:cursor-pointer" href={data.homepage}>
              {data?.homepage}
            </a>
            for å registrere skaden, eller ring kundeservice.
          </p>
        )}
      </Stack>
      <Stack spacing="xl" className="ap:py-xl">
        {findClaim?.number && (
          <TinyBox title={`Telefonnummer Kundeservice`} actionComponent={<Clipboard text={findClaim?.number} />}>
            <p className="ap:text-primaryLight">{findClaim?.number}</p>
          </TinyBox>
        )}
      </Stack>
      {data?.homepage && (
        <Button variant="primary" onClick={navigateToHome}>
          Gå til {data?.homepage}
        </Button>
      )}
    </Stack>
  )
}
